import { RouteRecordRaw } from "vue-router";
import { userMustBeLoggedIn, userMustHaveApproval } from "../../router/guards";

const routes: RouteRecordRaw[] = [
    {
        name: 'my-services',
        path: '/my-services',
        redirect: { name: 'my-service-listing' },
        component: () => import('./my-services-page.vue'),
        beforeEnter: [userMustBeLoggedIn, userMustHaveApproval],
        children: [
            {
                name: 'my-service-listing',
                path: 'listing',
                component: () => import('./my-services-listing-page.vue')
            },
            {
                name: 'service-details',
                path: ':serviceId/details',
                component: () => import('./my-services-detail-page.vue'),
                props: true,
                children: [
                    {
                        name: 'service-details-package',
                        path: 'package',
                        component: () => import('./update-package-service-form.vue'),
                    },
                    {
                        name: 'service-details-individual',
                        path: 'individual',
                        component: () => import('./update-individual-service-form.vue'),
                    }
                ]
            }
        ]
    },
]

export default routes;